export default "__VITE_ASSET__$H6Yb6Bi__"